import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try {
      const raw = sessionStorage.getItem("cart");
      const parsed = raw ? JSON.parse(raw) : {};

      // 🔹 sécurise les qty au chargement
      Object.keys(parsed).forEach((id) => {
        parsed[id].qty = Math.floor(parsed[id].qty || 0);
      });

      return parsed;
    } catch {
      return {};
    }
  });

  const addToCart = (id, product) =>
    setCart((c) => {
      if (c[id]) {
        return {
          ...c,
          [id]: { ...c[id], qty: Math.floor(c[id].qty + 1) },
        };
      }

      return {
        ...c,
        [id]: { product, qty: 1 },
      };
    });

  const inc = (id, stock) =>
    setCart((c) => {
      if (!c[id]) return c;

      const maxQty = Math.min(stock, 12);
      const nextQty = Math.floor(c[id].qty + 1);

      return {
        ...c,
        [id]: {
          ...c[id],
          qty: Math.min(nextQty, maxQty),
        },
      };
    });

  const dec = (id) =>
    setCart((c) => {
      if (!c[id]) return c;

      const next = Math.floor(Math.max(c[id].qty - 1, 0));

      if (next === 0) {
        const { [id]: _omit, ...rest } = c;
        return rest;
      }

      return {
        ...c,
        [id]: { ...c[id], qty: next },
      };
    });

  const clear = () => setCart({});

  useEffect(() => {
    try {
      sessionStorage.setItem("cart", JSON.stringify(cart));
    } catch {}
  }, [cart]);

  const value = useMemo(() => ({ cart, addToCart, inc, dec, clear }), [cart]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within <CartProvider />");
  return ctx;
}